import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

interface EndShiftModalProps {
  // Zachowane dla zgodności z wywołaniem w Layout — nieużywane po uproszczeniu modalu.
  activeItem?: unknown;
  selectedShift?: 'zmiana_1' | 'zmiana_2' | null;
  selectedLineId?: number | null;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Zakończenie zmiany to teraz zwykłe potwierdzenie — bez wymuszania wpisywania statusu
 * ani ilości dla aktywnej pozycji. Ewentualna pozycja „w trakcie" zostaje bez zmian.
 * (Wcześniej modal wymagał wyboru statusu i podania ilości; usunięte na życzenie.)
 */
const EndShiftModal: React.FC<EndShiftModalProps> = ({ onConfirm, onCancel }) => {
  const { t } = useLanguage();

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          padding: '30px',
          borderRadius: '12px',
          maxWidth: '500px',
          width: '90%',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        }}
      >
        <h3 style={{ marginTop: 0, color: '#dc3545', marginBottom: '20px' }}>
          {t('shift.endShiftTitle')}
        </h3>
        <p style={{ fontSize: '14px', marginBottom: '20px', color: '#4a5568' }}>
          {t('shift.endShiftConfirmQuestion')}
        </p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            style={{
              padding: '10px 20px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
            }}
          >
            {t('common.cancel')}
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '10px 20px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '500',
            }}
          >
            {t('shift.endShiftConfirm')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EndShiftModal;
